"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var _ = require("lodash");
var React = require("react");
var Remove = require("react-icons/lib/md/close");
var react_redux_1 = require("react-redux");
var Button_1 = require("./Button");
require("./style/TaskTag.css");
var TaskTag = /** @class */ (function (_super) {
    __extends(TaskTag, _super);
    function TaskTag() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = { mouseOver: false };
        return _this;
    }
    TaskTag.prototype.render = function () {
        var _this = this;
        var _a = this.props, highlighted = _a.highlighted, onClick = _a.onClick, showRemoveButton = _a.showRemoveButton, tag = _a.tag, touchable = _a.touchable;
        var mouseOver = this.state.mouseOver;
        return (React.createElement(Button_1.default, { className: this.containerClassName, onClick: function () {
                if (onClick) {
                    onClick();
                }
            }, onMouseOver: function () { return _this.setState({ mouseOver: true }); }, onMouseOut: function () { return _this.setState({ mouseOver: false }); } },
            React.createElement("div", { style: (!touchable && showRemoveButton && mouseOver)
                    ? { visibility: "hidden" } : {} }, tag),
            React.createElement("div", { className: "TaskTag-remove-button", style: (showRemoveButton && (touchable || mouseOver))
                    ? {} : { display: "none" } },
                React.createElement(Remove, null))));
    };
    Object.defineProperty(TaskTag.prototype, "containerClassName", {
        get: function () {
            var highlighted = this.props.highlighted;
            if (_.isBoolean(highlighted)) {
                return "TaskTag-container-" + (highlighted ? "highlighted" : "unhighlighted");
            }
            return "TaskTag-container";
        },
        enumerable: true,
        configurable: true
    });
    return TaskTag;
}(React.Component));
exports.default = react_redux_1.connect(function (_a) {
    var environment = _a.environment;
    return environment;
})(TaskTag);



//////////////////
// WEBPACK FOOTER
// ./src/component/TaskTag.tsx
// module id = 267
// module chunks = 0